import React from "react";
import { useState } from "react";

export const ShowingContext = React.createContext({});

export const ShowingProvider = ({children}) => {
    const [showing, setShowing] = useState(false);

    return (
        <ShowingContext.Provider value={{showing, setShowing}}>
            {children}
        </ShowingContext.Provider>
    )
}